export const EXPERTISE_COLORS = {
  'Business & Strategy': { bg: 'bg-blue-500/70', text: 'text-white' },
  'Game Design & Creative': { bg: 'bg-purple-500/70', text: 'text-white' },
  'Technology & Development': { bg: 'bg-cyan-500/70', text: 'text-white' },
  'Marketing & Community': { bg: 'bg-green-500/70', text: 'text-white' },
  'Production & Management': { bg: 'bg-orange-500/70', text: 'text-white' },
  'Legal & IP': { bg: 'bg-red-500/70', text: 'text-white' },
} as const;

export const ALLOWED_EXPERTISE = Object.keys(EXPERTISE_COLORS) as Array<
  keyof typeof EXPERTISE_COLORS
>;
